
import { Component, Input, Output  } from '@angular/core'; 
import { VehicleService } from '../_Services/vehicle.service';
import { CommonService } from '../_Services/common.service';
import { FormsModule, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';  
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  templateUrl: 'vehicle.component.html'
})
export class VehicleComponent {

    vehicles = [];  

    p: any = 1; 

    model: any = {};

    paginator = []; 
 

	constructor(private vehicleService: VehicleService, private route:ActivatedRoute) { }
 
	pageChanged(page: Number) {
		if(page == undefined) {
            page = 1;
        }
        this.p = page; 
		var debt_imported_id = this.route.snapshot.params['id'];
		this.vehicleService.getVehicles(debt_imported_id, page, this.model).subscribe(result => {
                console.log(result.paginator);
                this.vehicles = result.data;
                this.paginator = result.paginator; 
            });  
	}
	ngOnInit() { 
		var debt_imported_id = this.route.snapshot.params['id'];
		this.vehicleService.getVehicles(debt_imported_id, this.p, null).subscribe(result => {
                console.log(this.p);
                this.vehicles = result.data;
                this.paginator = result.paginator; 
            });  
	}
}


// WEBPACK FOOTER //
// ./src/app/debts/vehicle.component.ts